export const TASK_COMPOSER_PLACEHOLDERS = {
  engineering: "Build a reusable settings panel for the deployment dashboard.",
  research: "Research competitor onboarding patterns and summarize the best ideas.",
  comms: "Draft a concise launch update for users and partners.",
  logistics: "Organize the next sprint handoff and list the dependencies.",
  strategy: "Evaluate the roadmap tradeoffs and recommend the next priority.",
};

export function getTaskComposerPlaceholder(zoneId, zoneName) {
  return (
    TASK_COMPOSER_PLACEHOLDERS[zoneId] ||
    `Add a concrete task for ${zoneName || "this department"}.`
  );
}
